<template>
    <v-container>

<!--    <h1>Smarte bygg</h1>-->

      <v-row justify="start" class="align-center">
        <v-col cols="12" md="6" class="text-center">
          <h2>
            Hvorfor intelligente bygg?
          </h2>
          <p>

            SiteSense spesialiserer seg på
            bygg-automasjonsløsninger.<br>
            Løsningen vår er et
            skreddersydd dashbord som legges over alle
            nåværende systemer i næringsbygg.<br><br>
            Vi skiller oss fra andre leverandører der vi kan integrere
            allerede investerte løsninger og komponenter.<br><br>
            Vårt system baserer seg på kunstig intelligens til å forutse
            faktiske behov. <br>
            Samtidig gir løsningen vår mulighet for at for eks. ventilasjon og gulvvarme samkjøres istedet for å motarbeide hverandre.<br>
            <br>
            På denne og mange andre måter kan vår teknologi
            muliggjøre mye smartere bygg og dermed spare både miljøet
            og strømkostnader uten å gå på bekostning av komfort!<br><br>
            ...Og dere kan fokusere på det som er deres kjernevirksomhet.

          </p>

        </v-col>
        <v-col cols="6"  v-if="$vuetify.breakpoint.mdAndUp">
          <v-img class="mx-auto rounded"  :height="430" :width="1000" :src="require('../assets/mockup-of-a-happy-woman-with-a-tank-top-meditating-in-a-modern-living-room-37187-r-el2.png')"></v-img>
        </v-col>

<!--        <v-col cols="12" md="6">-->
<!--          <h2>-->
<!--            Tiltak-->
<!--          </h2>-->
<!--          <p>-->
<!--            Tiltakene som kan utføres i byggene er mange, og flere tiltak gir større innsparinger.-->
<!--            Løsningene er skalerbare slik at man fint kan starte med enklere tiltak og bygge på med flere etterhvert.-->
<!--          </p>-->
<!--        </v-col>-->
      </v-row>

  <!--    <v-toolbar-->
  <!--        flat-->
  <!--        color="primary"-->
  <!--    >-->


  <!--        <v-toolbar-title>tabs w illustrations etc..</v-toolbar-title>-->
  <!--        </v-toolbar>-->

<!--          <v-tabs :vertical="$vuetify.breakpoint.mdAndUp">-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-office-building-->
<!--              </v-icon>-->
<!--              Ett bygg i praksis-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-thermometer-->
<!--              </v-icon>-->
<!--              Styring av varme-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-lightbulb-->
<!--              </v-icon>-->
<!--              Styring av lys-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-fan-->
<!--              </v-icon>-->
<!--              Styring av ventilasjon-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-power-plug-->
<!--              </v-icon>-->
<!--              Energiforbruk-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-leaf-->
<!--              </v-icon>-->
<!--              Inneklima-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-water-->
<!--              </v-icon>-->
<!--              Fukt og lekkasje-->
<!--            </v-tab>-->

<!--            <v-tab>-->
<!--              <v-icon left>-->
<!--                mdi-door-open-->
<!--              </v-icon>-->
<!--              Dører og vinduer-->
<!--            </v-tab>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Et bygg i praksis-->
<!--                  </p>-->
<!--                  SiteSense BMS er et universalt toppsystem som kan samle alle nye og eksisterende styringssystemer og sensorer i dine bygg, noe som muliggjør automasjonsregler på kryss av systemer og tilogmed lokasjoner.-->

<!--                  Vi gjenbruker eksisterende systemer overalt det er mulig, og kan komplimentere med nye kablede eller trådløse sensorer for å utvide funksjonalitet og gjøre bygget enda smartere.-->

<!--                  En sentral gateway fra oss blir plassert i bygget som støtter de aller fleste industristandard protokoller og signaltyper slik av investeringen blir lavest mulig for dere.-->

<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Styring av varme-->
<!--                  </p>-->
<!--                  Smart varmestyring kan gjenbruke eksisterende løsninger (panelovner, vannbåren, varmepumper osv) ved å sette på kablede eller trådløse aktuatorer som styres intelligent basert på f.eks. tid, tilstedeværelse, gjeldende strømpriser og lignende.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Styring av lys-->
<!--                  </p>-->
<!--                  Enkel smart lysstyring kan oppnås ved å bruke kombinerte frittstående bevegelsessensorer (uten tilkobling til skyen) eller om det ønskes enda smartere styring og flere muligheter kan lysbrytere erstattes med smarte lysbrytere kombinert med bevegelsessensorer . Effektiv og kostnadseffektiv montering.-->

<!--                  Eksisterende løsninger med aktuatorer, DALI, KNX og lignende kan også enkelt integreres.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Styring av ventilasjon-->
<!--                  </p>-->
<!--                  Smart styring av ventilasjon gjøres med blant annet CO2 sensorer og smarte spjeld, med trådløs eller kablet kommunikasjon. Her kan man også oppnå muligheter for å individuelt styre hvert enkelt kontor/rom ut ifra behov/preferanser, og dermed begrense det totale effektforbruket på ventilasjonsanlegget basert på faktiske behov.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Energiforbruk-->
<!--                  </p>-->
<!--                  Med integrasjon med AMS målere kan vi måle strømforbruk i nær sanntid (hvert 10.sekund). I tillegg til å kontinuerlig ha data, kan bygget automatiseres til å unngå «topper» mht. strømforbruket. Når terskelverdier overskrides kan ikke-kritiske elementer som trekker strøm i bygget stenges ned. Dette kan bidra til store besparelser og redusert nettleie.  Individuelle strømforbrukere kan måles pr. kurs eller helt ned på panelovn nivå for å avdekke besparingspotensialer.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Inneklima-->
<!--                  </p>-->
<!--                  Inneklima i bygg kan måles med både veggmonterte og frittstående “MultiSense” enheter, som måler temperatur, fukt, lys, CO2 og bevegelse. All data blir kontinuerlig lagret i skyen slik at man til enhver tid har dokumentasjonen tilgjengelig. Styring av varme, ventilasjon m.m. kan baseres på disse enhetene.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Fukt og lekkasje-->
<!--                  </p>-->
<!--                  Vannlekkasjer kan detekteres og varsles om ved hjelp av både fuktsensorer og sensorer som måler vanntrykk. Eksempelvis tyder lavere enn normalt vanntrykk ofte på en lekkasje.-->

<!--                  Ved deteksjon av lekkasje kan vanntilførsel automatisk stenges.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--            <v-tab-item>-->
<!--              <v-card flat>-->
<!--                <v-card-text>-->
<!--                  <p>-->
<!--                    Dører og vinduer-->
<!--                  </p>-->
<!--                  Vi leverer sensorer som indikerer og varsler om vinduer og dører er åpne, samt sjokksensorer som detekterer knusing av vinduer. I forbindelse med smart styring kan eksempelvis varmekilder justeres til frostsikring ved åpne vinduer eller deaktivere aktiv kjøling.-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->

<!--          </v-tabs>-->


  <!--<v-row>-->
  <!--  <v-col cols="3">-->
  <!--    <v-list>-->
  <!--      <v-list-item>-->

  <!--        <v-list-item-avatar>-->
  <!--          <v-icon>mdi-folder</v-icon>-->
  <!--        </v-list-item-avatar>-->
  <!--        <v-list-item-title>-->
  <!--          title-->
  <!--        </v-list-item-title>-->


  <!--      </v-list-item>-->
  <!--    </v-list>-->

  <!--  </v-col>-->
  <!--  <v-col>-->

  <!--  </v-col>-->
  <!--</v-row>-->

      <v-row justify="start" class="align-center">

        <v-col cols="12" md="6"  v-if="$vuetify.breakpoint.mdAndUp">
          <v-img class="mx-auto" :width="1050" :src="require('../assets/png-responsive-mockup-of-a-tv-macbook-pro-ipad-and-iphone-in-landscape-position-a11927.png')"></v-img>


        </v-col>
        <v-col cols="12" md="6" class="text-center">
<!--        <v-card>-->
          <h2>
            Dashboard og mobil app
          </h2>
            Løsningen er skybasert og via dashboard eller mobil app får man overblikk og innsikt i samtlige bygg.<br/><br/>
            Her får man blant annet sensordata, varslinger, muligheter for styring, analyse og rapporter.<br/>
            <br/>
          Raskt, enkelt og fra hvorsomhelst.

        </v-col>


<!--        <v-col>-->
<!--        <v-card>-->
<!--          <v-card-title>-->
<!--            Ofte stilte spørsmål-->
<!--          </v-card-title>-->
<!--          <v-card-text>-->
<!--            expanding cards-->
<!--            <v-expansion-panels>-->
<!--              <v-expansion-panel>-->
<!--                <v-expansion-panel-header>Hvorfor SiteSense?</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  SiteSense har bred erfaring med sensorer, automasjon og IoT,-->
<!--                  og i forbindelse med integrasjoner med SD anlegg har vi kunnskaper om alle kjente protokoller som benyttes.-->
<!--                  I tillegg innehar vi kompetanse innen design og utvikling av både hardware og software.-->

<!--                  Dette gjør oss i stand til å levere solide løsninger – både enkle og spesialtilpassede løsninger.-->
<!--                  Åpenhet med tanke på løsninger og teknologi er viktig for oss,-->
<!--                  og vi leverer løsninger som baserer seg på åpne standard protokoller og hardware.-->
<!--                  Dette betyr i større grad leverandøruavhengighet for våre kunder.-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->

<!--              <v-expansion-panel>-->
<!--                <v-expansion-panel-header>Er trådløs kommunikasjon stabilt?</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  Mange sverger fortsatt til kablede løsninger i tro om at trådløse løsninger ikke er like stabile,-->
<!--                  og tenker ofte på vanlige WiFi nettverk. Verden går videre og framtiden er trådløs.-->
<!--                  Den trådløse teknologien er godt utprøvd og har eksistert lenge,-->
<!--                  og vår mangeårige erfaring tilsier at dette er like stabilt som kablede løsninger.-->
<!--                  Alle sensor- og styringsenheter kommuniserer via dedikerte lukket MESH nettverk (altså ikke WiFi),-->
<!--                  og vi gjennomfører grundig analyse og testing av disse nettverkene i alle våre leveranser.-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->

<!--              <v-expansion-panel>-->
<!--                <v-expansion-panel-header>Hva er forskjellen på løsninger fra SiteSense og andre SD-anlegg?</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  Mange spør om SiteSense leverer SD-anlegg, og svaret er ja.-->
<!--                  Bygg kan med trådløs IoT teknologi i sin helhet automatiseres,-->
<!--                  og i like stor og ofte større grad enn med tradisjonelle SD-anlegg.-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->

<!--              <v-expansion-panel>-->
<!--                <v-expansion-panel-header>Hvor mye koster løsningene i forhold til tradisjonelle SD-anlegg?</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  Med hensyn til priser er et fasitsvar som gjelder alle bygg og leverandører er umulig å komme med.-->
<!--                  Erfaringsmessig ligger trådløse IoT baserte styringssystemer på under halvparten av prisen på tradisjonelle SD-anlegg.-->
<!--                  Grunnen er rimeligere sensor- og styringsenheter,-->
<!--                  lavere krav til utstyr som må installeres (PLS-er) og ikke minst enorme besparelser på installasjon pga. mindre kabling.-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->

<!--              <v-expansion-panel>-->
<!--                <v-expansion-panel-header>Hva skjer hvis byggene mister tilgang til internett?</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  All styring og automasjon i byggene fungerer uavhengig av Internett og plattformer i skyen.-->
<!--                  Ved brudd på tilgang til Internett vil man kun miste muligheter i dashboard og mobil app for å se status, sensordata og lignende.-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->

<!--              <v-expansion-panel>-->
<!--                <v-expansion-panel-header>Hvordan lagres data fra sensorer og hvor lenge?</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  Alle sensorer kommuniserer med skyen og all data blir kontinuerlig lagret,-->
<!--                  og blir lagret i minimum 3 år avhengig av avtaler.-->
<!--                  Dette gjør at man til enhver tid har siste data samt historikk tilgjengelig og enkelt kan kjøre ut rapporter til dokumentasjon.-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->

<!--            </v-expansion-panels>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--        </v-col>-->




      </v-row>


      <v-row justify="start" class="align-center">
        <v-col cols="12" md="6" class="text-center">
          <h2>
            Usikker på om dette er for deg?
          </h2>
          <p>

            Du har garantert noe å vinne.<br><br>
            Men før vi kan si hvordan og hvor mye, så kan en kartleggingsfase være en god plass å starte.<br><br>

            Vi installerer multisensorer i alle ønskelige rom i ditt bygg, <br>og analyserer målingene slik at vi kan komme med en anbefaling til neste steg.<br><br>

            Ofte ser vi en energibesparelse på rundt 30% med veldig enkle og rimelige tiltak som resultat etter en slik kartlegging.
            <br>


          </p>

        </v-col>
        <v-col cols="6"  v-if="$vuetify.breakpoint.mdAndUp">
          <v-img class="mx-auto rounded"  :height="450" :width="1050" :src="require('../assets/business-woman-with-lg-flat-screen-tv-mockup-template-90980.png')"></v-img>
        </v-col>

        <!--        <v-col cols="12" md="6">-->
        <!--          <h2>-->
        <!--            Tiltak-->
        <!--          </h2>-->
        <!--          <p>-->
        <!--            Tiltakene som kan utføres i byggene er mange, og flere tiltak gir større innsparinger.-->
        <!--            Løsningene er skalerbare slik at man fint kan starte med enklere tiltak og bygge på med flere etterhvert.-->
        <!--          </p>-->
        <!--        </v-col>-->
      </v-row>





      <v-row>
        <v-col cols="12" class="text-center">
          Det er valgfritt i hvor stor grad man ønsker å automatisere byggene. Teknologien er skalerbar og byggene kan oppgraderes stegvis. Nedenfor er eksempler på løsninger som kan innføres.
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="4" v-for="(card, index) in cards" v-bind:key="'infcard' + index">
          <!--          <v-card style="width: 100%">-->
          <v-row class="ma-0 pa-0">
            <!--            <v-col class="ma-0 pa-0">-->

            <v-card class="d-flex align-center justify-center" height="50px" width="50px"
                    style="background: linear-gradient(135deg, #1ed6b2 0%, #1ed6b2 50%, #1bbc9c 50%, #1bbc9c 100%)">
              <v-icon style="font-size: 32px; color: white">
                {{card.icon}}
              </v-icon>
            </v-card>

            <!--            </v-col>-->
            <!--            <v-col class="ma-0 pa-0">-->
            <v-subheader style="word-break: break-word">
              {{card.title}}
            </v-subheader>
            <!--            </v-col>-->
          </v-row>

          <v-row class="ma-0">
            <v-col class="pa-0" cols="12">
              <v-card-text>
                {{card.text}}
              </v-card-text>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

    </v-container>
</template>

<script>

export default {
  name: 'BMS-view',
  data: () => ({
    cards: [
      {
        icon: 'mdi-lightbulb',
        title: 'SMART LYSSTYRING',
        text: 'Intelligent styring av lys ved bruk av blant annet bevegelses- og lyssensorer, samt smarte tidsplaner, gir lavere energiforbruk og bedre innemiljø. Varslinger når lyspærer og rør må byttes sparer driftere av bygg enormt med tid.',
      },
      {
        icon: 'mdi-air-filter',
        title: 'SMART VENTILASJON',
        text: 'Intelligent styring og monitorering av HVAC basert på flere sensorer sørger for optimalt inneklima og energiforbruk, i tillegg varslinger ved feil.',
      },
      {
        // icon: 'mdi-thermostat',
        icon: 'mdi-thermometer',
        title: 'SMART VARME',
        text: 'Intelligent styring av varme ved bruk av sensorer og smart programmering gir bedre innemiljø og lavere energiforbruk.',
      },
      {
        icon: 'mdi-leaf',
        title: 'INNEKLIMA MÅLINGER',
        text: 'Kontinuerlig inneklima målinger, blant annet temperatur, fukt, CO2 og luftkvalitet gir godt grunnlag for dokumentasjon og driftere av bygg sparer tid på å slippe manuelle kontroller.',
      },
      {
        icon: 'mdi-account-group',
        title: 'STØV OG TILSTEDEVÆRELSE',
        text: 'Monitorering av støv og hvor mye lokaler har vært i bruk, bidrar til besparelser ved å minske unødvendig vasking.',
      },
      {
        icon: 'mdi-cellphone',
        title: 'FJERNSTYRING',
        text: 'Elementer i byggene kan enkelt fjernstyres via mobil app eller dashboard.',
      },
      {
        icon: 'mdi-alert',
        title: 'SIKKERHET OG VARSLING',
        text: 'Kontinuerlig oversikt over status på komponenter i byggene og tidlige varslinger ved avvik bidrar til enklere og billigere drift.',
      },
      {
        icon: 'mdi-content-copy',
        title: 'RAPPORTERING',
        text: 'Innsamling av sensordata i skyen gir enkel oversikt og dokumentasjon, og grunnlag for ytterligere besparelser og effektivisering.',
      },
      {
        icon: 'mdi-server',
        title: 'PLATTFORM',
        text: 'En felles åpen plattform og tjenester i skyen sørger for datainnsamling og samhandling med andre systemer.',
      },
    ]
  }),
  mounted () {
    window.scrollTo(0, 0)
  },

}
</script>
